
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

export class PaginatorI18n {
    constructor(private readonly translate: TranslateService) {}
    getPaginatorIntl(): MatPaginatorIntl {
        const paginatorIntl = new MatPaginatorIntl();
        this.translate.get('NEXT_PAGE').subscribe((res: any) => {
          paginatorIntl.nextPageLabel = res
        })
        this.translate.get('PREVIOUS_PAGE').subscribe((res: any) => {
            paginatorIntl.previousPageLabel = res;
        })

        // paginatorIntl.firstPageLabel = this.translate.instant('BUTTONS.NEXT');
        // paginatorIntl.lastPageLabel = this.translate.instant('BUTTONS.NEXT');
        return paginatorIntl;
    }
}